var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "playerEdit" }, [
    _c(
      "div",
      { staticClass: "formTable" },
      [
        _c(
          "el-form",
          {
            ref: "newsForm",
            staticClass: "newsForm",
            attrs: { model: _vm.newsForm, rules: _vm.rules },
          },
          [
            _c("el-row", { staticClass: "formTitle" }, [_vm._v("新增新闻")]),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "标题",
                      "label-width": "120px",
                      prop: "newsTitle",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入新闻标题" },
                      model: {
                        value: _vm.newsForm.newsTitle,
                        callback: function ($$v) {
                          _vm.$set(_vm.newsForm, "newsTitle", $$v)
                        },
                        expression: "newsForm.newsTitle",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "所属分类",
                          "label-width": "120px",
                          prop: "newsTypeId",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择所属分类" },
                            model: {
                              value: _vm.newsForm.newsTypeId,
                              callback: function ($$v) {
                                _vm.$set(_vm.newsForm, "newsTypeId", $$v)
                              },
                              expression: "newsForm.newsTypeId",
                            },
                          },
                          _vm._l(_vm.newsTypeList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.newsTypeName,
                                value: item.id,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "概述",
                          "label-width": "120px",
                          prop: "newsSummary",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "20",
                            "show-word-limit": "",
                            placeholder: "请输入新闻概述",
                          },
                          model: {
                            value: _vm.newsForm.newsSummary,
                            callback: function ($$v) {
                              _vm.$set(_vm.newsForm, "newsSummary", $$v)
                            },
                            expression: "newsForm.newsSummary",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "排序",
                          "label-width": "120px",
                          prop: "sort",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "" },
                          model: {
                            value: _vm.newsForm.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.newsForm, "sort", $$v)
                            },
                            expression: "newsForm.sort",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "外链", "label-width": "120px" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入外链。" },
                          model: {
                            value: _vm.newsForm.newsUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.newsForm, "newsUrl", $$v)
                            },
                            expression: "newsForm.newsUrl",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "创建时间",
                          "label-width": "120px",
                          prop: "createTime",
                        },
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                format: "yyyy-MM-dd HH:mm:ss",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                type: "datetime",
                                placeholder: "选择日期时间",
                              },
                              model: {
                                value: _vm.newsForm.createTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newsForm, "createTime", $$v)
                                },
                                expression: "newsForm.createTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "fxsc" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "附件", "label-width": "120px" } },
                  [
                    _c("FileUpload", {
                      attrs: { title: "文件上传", accept: "" },
                      on: { successData: _vm.getUploadFileData },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.fileList, function (file, index) {
                      return _c("p", { key: index }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(file.fileName) +
                            "\n            "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "el-icon-delete",
                            on: {
                              click: function ($event) {
                                return _vm.del(index)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ])
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "内容", "label-width": "120px" } },
                  [
                    _c("Editor", {
                      attrs: {
                        editorId: "editor",
                        editorContent: _vm.newsForm.newsContent,
                      },
                      on: {
                        "update:editorContent": function ($event) {
                          return _vm.$set(_vm.newsForm, "newsContent", $event)
                        },
                        "update:editor-content": function ($event) {
                          return _vm.$set(_vm.newsForm, "newsContent", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-col",
          { staticClass: "save", attrs: { span: 24 } },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.onSubmit("newsForm")
                  },
                },
              },
              [_vm._v("提交")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.cancel },
              },
              [_vm._v("取消")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }